(() => {
  'use strict';

  const initMellerAtcModal = () => {
    const modal = document.getElementById('meller-atc-modal');
    if (!modal || modal.dataset.mellerAtcReady === 'true') return;

    modal.dataset.mellerAtcReady = 'true';

    const itemsEl = document.getElementById('meller-atc-items');
    const cartCountEl = document.getElementById('meller-atc-cart-count');
    const cartTotalEl = document.getElementById('meller-atc-cart-total');
    const freeShippingEl = document.getElementById('meller-atc-free-shipping');
    const freeShippingMessageEl = document.getElementById('meller-atc-free-shipping-message');
    const freeShippingTrackEl = document.getElementById('meller-atc-free-shipping-track');
    const freeShippingNoteEl = document.getElementById('meller-atc-free-shipping-note');
    const closeBtn = document.getElementById('meller-atc-close');
    const continueBtn = document.getElementById('meller-atc-continue');
    const freeShippingThreshold = parseInt(freeShippingEl?.dataset.threshold || '450000', 10) || 450000;

    let isUpdatingQty = false;
    let latestCart = null;
    let preferCentralModalUntil = 0;

    const formatMoney = (cents, currencyCode) => {
      try {
        return new Intl.NumberFormat('es-UY', {
          style: 'currency',
          currency: currencyCode || 'UYU',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }).format((cents || 0) / 100);
      } catch (e) {
        return '$' + ((cents || 0) / 100).toFixed(2);
      }
    };

    const formatShippingMoney = (cents) => {
      const amount = Math.max(0, cents) / 100;

      return '$' + amount.toLocaleString('es-UY', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
    };

    const escapeHtml = (value) => {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    };

    const closeModal = () => {
      if (modal.open) modal.close();
    };

    const closeCartDrawer = () => {
      const drawerComponents = document.querySelectorAll('cart-drawer-component');

      drawerComponents.forEach((component) => {
        if (typeof component.close === 'function') {
          try {
            component.close();
          } catch (_error) {}
        }

        if (typeof component.closeDialog === 'function') {
          try {
            component.closeDialog();
          } catch (_error) {}
        }
      });

      document.querySelectorAll(
        'cart-drawer-component dialog[open], ' +
        '.cart-drawer__dialog[open], ' +
        '#CartDrawer[open], ' +
        '#cart-drawer[open], ' +
        '.cart-drawer[open]'
      ).forEach((dialog) => {
        if (typeof dialog.close === 'function') {
          try {
            dialog.close();
            return;
          } catch (_error) {}
        }

        dialog.removeAttribute('open');
      });

      document.querySelectorAll('.cart-drawer.is-open, .cart-drawer.active, .cart-drawer.open').forEach((drawer) => {
        drawer.classList.remove('is-open', 'active', 'open');
      });
    };

    const enforceCentralModalSurface = () => {
      closeCartDrawer();
      window.requestAnimationFrame(closeCartDrawer);
      window.setTimeout(closeCartDrawer, 80);
      window.setTimeout(closeCartDrawer, 220);
      window.setTimeout(closeCartDrawer, 520);
    };

    const getEventSource = (event) => {
      const detail = event && event.detail ? event.detail : {};
      return String(detail.source || detail.data?.source || detail.sourceId || '').toLowerCase();
    };

    const isCartManagementSource = (event) => {
      const source = getEventSource(event);
      const target = event && event.target instanceof Element ? event.target : null;

      if (
        /cart-drawer|cart_drawer|drawer|cart-items|cart_items|cart-page|cart_page|quantity|remove|change|discount/.test(source)
      ) {
        return true;
      }

      if (
        target &&
        target.closest(
          'cart-drawer-component, .cart-drawer, .cart-drawer__dialog, .cart-page, #meller-atc-modal'
        )
      ) {
        return true;
      }

      return false;
    };

    const isCartDrawerOpen = () => Boolean(
      document.querySelector(
        'cart-drawer-component dialog[open], ' +
        '.cart-drawer__dialog[open], ' +
        '#CartDrawer[open], ' +
        '#cart-drawer[open], ' +
        '.cart-drawer[open]'
      )
    );

    const shouldOpenModalForCartAdded = (event) => {
      if (modal.open) return false;
      if (isCartDrawerOpen()) return false;
      if (isCartManagementSource(event)) return false;

      return true;
    };

    const fetchCart = async () => {
      const response = await fetch('/cart.js', {
        headers: {
          Accept: 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Cart fetch failed');
      }

      return response.json();
    };

    const changeCartItem = async (itemKey, quantity) => {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: quantity
        })
      });

      if (!response.ok) {
        throw new Error('Cart change failed');
      }

      return response.json();
    };

    const setModalUpdating = (state) => {
      isUpdatingQty = state;
      modal.classList.toggle('is-updating-qty', state);

      const buttons = modal.querySelectorAll('.meller-atc-modal__qty-btn');
      buttons.forEach((button) => {
        button.disabled = state || button.hasAttribute('data-disable-base');
      });
    };

    const renderCartItems = (cart) => {
      if (!itemsEl) return;

      latestCart = cart;

      if (!cart?.items?.length) {
        itemsEl.innerHTML = `
          <div class="meller-atc-modal__empty">
            Tu carrito está vacío
          </div>
        `;
        return;
      }

      itemsEl.innerHTML = cart.items.map((item) => {
        const image = item.featured_image?.url || '';
        const title = item.product_title || item.title || 'Producto';
        const safeTitle = escapeHtml(title);

        const variant = item.variant_title && item.variant_title !== 'Default Title'
          ? `<div class="meller-atc-modal__item-variant">${escapeHtml(item.variant_title)}</div>`
          : '';

        const minusDisabled = item.quantity <= 1 ? 'disabled data-disable-base="true"' : '';

        return `
          <div class="meller-atc-modal__item" data-item-key="${escapeHtml(item.key)}">
            <div class="meller-atc-modal__item-image-wrap">
              <img
                class="meller-atc-modal__item-image"
                src="${escapeHtml(image)}"
                alt="${safeTitle}"
                loading="lazy"
                fetchpriority="auto"
                decoding="async"
              >
            </div>

            <div class="meller-atc-modal__item-info">
              <div class="meller-atc-modal__item-title">${safeTitle}</div>
              ${variant}

              <div class="meller-atc-modal__item-bottom">
                <div class="meller-atc-modal__qty-control">
                  <button
                    type="button"
                    class="meller-atc-modal__qty-btn js-meller-qty-minus"
                    data-key="${escapeHtml(item.key)}"
                    data-current-qty="${item.quantity}"
                    ${minusDisabled}
                    aria-label="Restar unidad"
                  >
                    −
                  </button>

                  <span class="meller-atc-modal__qty-value">${item.quantity}</span>

                  <button
                    type="button"
                    class="meller-atc-modal__qty-btn js-meller-qty-plus"
                    data-key="${escapeHtml(item.key)}"
                    data-current-qty="${item.quantity}"
                    aria-label="Sumar unidad"
                  >
                    +
                  </button>
                </div>

                <div class="meller-atc-modal__item-total">
                  ${formatMoney(item.final_line_price || item.line_price || 0, cart.currency)}
                </div>
              </div>
            </div>
          </div>
        `;
      }).join('');
    };

    const renderCartMeta = (cart) => {
      if (cartCountEl) {
        const count = cart.item_count || 0;
        cartCountEl.textContent = `Hay ${count} producto${count === 1 ? '' : 's'} en tu carrito`;
      }

      if (cartTotalEl) {
        cartTotalEl.textContent = `Total: ${formatMoney(cart.total_price || 0, cart.currency)}`;
      }
    };

    const renderFreeShippingProgress = (cart) => {
      if (!freeShippingEl || !freeShippingMessageEl || !freeShippingTrackEl) return;

      const total = parseInt(cart?.total_price || 0, 10);
      const progressValue = Math.min(Math.max(total, 0), freeShippingThreshold);
      const progress = freeShippingThreshold > 0
        ? Math.min((progressValue / freeShippingThreshold) * 100, 100)
        : 100;
      const remaining = Math.max(0, freeShippingThreshold - total);
      const reachedFreeShipping = total >= freeShippingThreshold;

      freeShippingEl.classList.toggle('meller-atc-free-shipping--qualified', reachedFreeShipping);
      freeShippingEl.style.setProperty('--meller-atc-free-shipping-progress', `${progress}%`);
      freeShippingTrackEl.setAttribute('aria-valuenow', String(progressValue));

      if (reachedFreeShipping) {
        freeShippingMessageEl.innerHTML =
          'YA TENÉS <span class="meller-atc-free-shipping__highlight">ENVÍO GRATIS</span> 😎';

        if (freeShippingNoteEl) {
          freeShippingNoteEl.textContent =
            'VERÁS EL COSTO DEL ENVÍO DESCONTADO EN EL DESGLOSE ANTES DE FINALIZAR TU COMPRA';
        }
      } else {
        freeShippingMessageEl.innerHTML =
          `TE FALTAN <strong>${formatShippingMoney(remaining)}</strong> PARA ` +
          '<span class="meller-atc-free-shipping__highlight">ENVÍO GRATIS</span>';

        if (freeShippingNoteEl) {
          freeShippingNoteEl.textContent = '';
        }
      }
    };

    const renderModalFromCart = (cart) => {
      latestCart = cart;
      renderCartItems(cart);
      renderCartMeta(cart);
      renderFreeShippingProgress(cart);
    };

    const refreshModal = async () => {
      const cart = await fetchCart();
      renderModalFromCart(cart);
      return cart;
    };

    const updateItemQuantity = async (itemKey, newQty) => {
      if (!itemKey || isUpdatingQty) return;
      if (newQty < 1) return;

      try {
        setModalUpdating(true);

        const cart = await changeCartItem(itemKey, newQty);
        renderModalFromCart(cart);

        if (!cart?.items?.length) {
          closeModal();
          return;
        }

        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: {
            cart,
            source: 'meller-atc-modal'
          }
        }));
      } catch (error) {
        console.error('Meller ATC quantity update error:', error);

        try {
          await refreshModal();
        } catch (refreshError) {
          console.error('Meller ATC refresh error:', refreshError);
        }
      } finally {
        setModalUpdating(false);
      }
    };

    closeBtn?.addEventListener('click', closeModal);
    continueBtn?.addEventListener('click', closeModal);

    itemsEl?.addEventListener('click', async (event) => {
      const minusBtn = event.target.closest('.js-meller-qty-minus');
      const plusBtn = event.target.closest('.js-meller-qty-plus');

      if (!minusBtn && !plusBtn) return;
      if (isUpdatingQty) return;

      const button = minusBtn || plusBtn;
      const itemKey = button.dataset.key;
      if (!itemKey) return;

      const itemEl = button.closest('.meller-atc-modal__item');
      const qtyEl = itemEl?.querySelector('.meller-atc-modal__qty-value');

      let currentQty = parseInt(button.dataset.currentQty || qtyEl?.textContent || '1', 10);

      if (!currentQty || currentQty < 1) {
        const item = latestCart?.items?.find((i) => i.key === itemKey);
        currentQty = item?.quantity || 1;
      }

      const nextQty = plusBtn ? currentQty + 1 : currentQty - 1;
      if (nextQty < 1) return;

      if (qtyEl) {
        qtyEl.textContent = nextQty;
      }

      await updateItemQuantity(itemKey, nextQty);
    });

    modal.addEventListener('click', (event) => {
      const box = modal.querySelector('.meller-atc-modal__box');
      if (!box) return;

      if (!box.contains(event.target)) {
        closeModal();
      }
    });

    [
      'cart:open',
      'cart:drawer:open',
      'cart-drawer:open',
      'drawer:open'
    ].forEach((eventName) => {
      document.addEventListener(
        eventName,
        () => {
          if (modal.open || Date.now() < preferCentralModalUntil) {
            enforceCentralModalSurface();
          }
        },
        true
      );
    });

    document.addEventListener(
      'cart:update',
      (event) => {
        if (isCartManagementSource(event) && Date.now() >= preferCentralModalUntil) {
          return;
        }

        if (modal.open || Date.now() < preferCentralModalUntil) {
          enforceCentralModalSurface();
        }
      },
      true
    );

    document.addEventListener('meller:cart-added', async (event) => {
      if (!shouldOpenModalForCartAdded(event)) return;

      preferCentralModalUntil = Date.now() + 2600;
      enforceCentralModalSurface();

      try {
        const cart = await refreshModal();
        if (!cart?.items?.length) return;

        enforceCentralModalSurface();

        if (!modal.open) {
          modal.showModal();
        }

        enforceCentralModalSurface();
      } catch (error) {
        console.error('Meller ATC modal error:', error);
      }
    });
  };

  if (document.readyState === 'complete') {
    initMellerAtcModal();
  } else {
    window.addEventListener('load', initMellerAtcModal, { once: true });
  }

  document.addEventListener('shopify:section:load', initMellerAtcModal);
})();
